import { Avatar, Badge, Button, List, message, Skeleton, Space, Typography } from 'antd';
import { PageHeader } from "@ant-design/pro-layout";
import { KeyOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { checkKeepaKey, getListKeepaKeys } from 'services/keepa-keys';

const KeepaKeys = () => {
  const [initLoading, setInitLoading] = useState<boolean>(false);
  const [loadingField, setLoadingField] = useState<boolean>(false);
  const [list, setList] = useState<any>([]);
  const [fieldUpdate, setFieldUpdate] = useState<string>('');

  const handleOnCheck = (key: string) => {
    setFieldUpdate(() => {
      setLoadingField(true);
      return key;
    })
    const params = { key };
    checkKeepaKey(params)
      .then(({ data: res }) => {
        message.success('Checked the keepa key');
        setList((prev: any) => prev.map((i: any) => i.keepaKey === key ? ({ ...i, tokens: res.tokensLeft }) : ({ ...i })))
      })
      .catch(() => message.error('Can not check the keepa key'))
      .finally(() => setLoadingField(false))
  }

  useEffect(() => {
    setInitLoading(true);
    getListKeepaKeys()
      .then(({ data: res }) => {
        const formatted = res.data.map((i: any) => ({
          ...i,
          id: Object.values(i._id)[0],
          tokens: null,
        }))
        setList(formatted)
      })
      .catch(() => message.error('Can not fetch the list of keepa keys'))
      .finally(() => setInitLoading(false));
  }, []);

  return (
    <>
    <Helmet>
      <title>Keepa Keys | Admin UI</title>
    </Helmet>
    <PageHeader
      className="page-header"
      title="Keepa Keys"
      footer={
        <List
          className="demo-loadmore-list"
          loading={initLoading}
          itemLayout="horizontal"
          dataSource={list}
          renderItem={(item: any) => (
            <List.Item
              actions={[
                <Button
                  type="primary"
                  key="list-check-btn"
                  onClick={() => handleOnCheck(item.keepaKey)}
                  loading={fieldUpdate === item.keepaKey && loadingField}
                >
                  Check
                </Button>,
              ]}
            >
              <List.Item.Meta
                avatar={<Avatar icon={<KeyOutlined />} />}
                title={
                  <Space direction="vertical">
                    <Typography.Text copyable italic>{item.keepaKey}</Typography.Text>
                    <Typography.Text><strong>Tokens left: </strong>{item.tokens}</Typography.Text>
                  </Space>
                }
              />
              <Badge
                text="Valid"
                status={item.isValid ? "success" : "error"}
              />
            </List.Item>
          )}
        />
        }
      />
    </>
  );
};

export default KeepaKeys;